import React from "react";
import "./ArrowRight.scss";
import Arrow from "images/arrow-in-right.inline.svg";

const ArrowRight = React.memo(({ className, color }) => (
    <Arrow className={`arrow-right arrow-right--${color} ${className}`} />
));

export default ArrowRight;
